import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

const Footer = () => {
  const { t } = useTranslation();

  const linkClass =
    "text-sm text-gray-300 hover:text-bgYellow transition-colors no-underline rounded-sm focus-visible:ring-2 focus-visible:ring-bgYellow focus-visible:ring-offset-2 focus-visible:ring-offset-black";

  return (
    <footer className="bg-black text-gray-300 pt-20 tablet:pt-16 pb-10 px-6 mobile:px-4">
      <div className="container-page">
        <div className="grid grid-cols-4 tablet:grid-cols-2 mobile:grid-cols-1 gap-10 pb-14">
          <div className="col-span-2 tablet:col-span-2 mobile:col-span-1">
            <img
              src="/skyglobal-removebg-preview.svg"
              alt="Sky Global"
              width="150"
              height="60"
              className="h-[60px] w-auto mb-5"
            />
            <p className="text-sm text-gray-300 leading-relaxed max-w-[46ch] mb-4">
              {t("footer.description")}
            </p>
            <p className="text-sm text-bgYellow">{t("footer.tagline")}</p>
          </div>

          <div>
            <h2 className="text-sm font-semibold text-white mb-5">{t("footer.company")}</h2>
            <ul className="space-y-3">
              <li>
                <NavLink to="/about" className={linkClass}>
                  {t("navbar.about")}
                </NavLink>
              </li>
              <li>
                <NavLink to="/solutions" className={linkClass}>
                  {t("navbar.solutions")}
                </NavLink>
              </li>
              <li>
                <NavLink to="/products" className={linkClass}>
                  {t("navbar.products")}
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact" className={linkClass}>
                  {t("navbar.contact")}
                </NavLink>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-semibold text-white mb-5">
              PT. SKYGLOBAL TEKNOLOGI INDONESIA
            </h2>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-bgYellow shrink-0 mt-0.5" aria-hidden="true" />
                <span className="text-sm text-gray-300 leading-relaxed">
                  Jl. Kejaksaan V G.172, Pondok Bambu, Duren Sawit, Jakarta Timur
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-bgYellow shrink-0" aria-hidden="true" />
                <a href="tel:+6281181288777" className={linkClass}>
                  +62 811 8128 8777
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-bgYellow shrink-0" aria-hidden="true" />
                <a href="mailto:bisnis@skyglobal.co.id" className={linkClass}>
                  bisnis@skyglobal.co.id
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-wrap items-center justify-between gap-4 text-sm text-gray-400">
          <p>
            © {new Date().getFullYear()} PT Skyglobal Teknologi Indonesia. {t("footer.rights")}
          </p>
          <ul className="flex items-center gap-6">
            <li>
              <NavLink to="/privacy" className={linkClass}>
                {t("footer.privacy")}
              </NavLink>
            </li>
            <li>
              <NavLink to="/terms" className={linkClass}>
                {t("footer.terms")}
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
